import {Injectable} from '@angular/core';
import {ChatNotification} from '../models';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ChatMessageAdapter} from './chat-message-adapter.service';
import * as moment from 'moment';
import {InMemoryStorageService} from 'angular-webstorage-service';
import {StoreKeys} from '@drl/core/store/store-keys.enum';
import {ChatCategory} from '@drl/core/store/models/chat-category.model';
import {cloneDeep, keyBy} from 'lodash';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';

@Injectable()
export class ChatNotificationAdapter implements IAdapter<ChatNotification> {
  constructor(
    private readonly chatMsgAdapter: ChatMessageAdapter,
    private readonly inMemoryStore: InMemoryStorageService,
    private readonly translateSvc: IpsTranslateService,
  ) {}

  adaptToModel(resp: any): ChatNotification {
    const msglength = 150;
    const chatCatsInStore: ChatCategory[] = cloneDeep(
      this.inMemoryStore.get(StoreKeys.CHAT_CATEGORIES),
    );
    const chatCatIdMap = keyBy(chatCatsInStore, 'id');
    const notif: ChatNotification = new ChatNotification();
    Object.assign(notif, resp);
    if (resp.message) {
      let category = 'direct message';
      notif.message = this.chatMsgAdapter.adaptToModel(resp.message);
      if (notif.message.categoryId) {
        category = chatCatIdMap[notif.message.categoryId].name;
      }
      notif.messageBody = `${notif.message.body.substring(0, msglength)}${
        notif.message.body.length > msglength ? '....' : ''
      }`;
      notif.messageTitle = `${
        notif.message.sender ? notif.message.sender.fullName : ''
      } ${this.translateSvc.translate.instant('sent in')} ${category} ${moment(new Date(notif.createdOn)).fromNow()}`;
    }
    notif.notificationTime = moment(new Date(notif.createdOn)).fromNow();
    return notif;
  }
  adaptFromModel(data: ChatNotification): any {
    const dataToSend = Object.assign({}, data);
    delete dataToSend.messageBody;
    delete dataToSend.notificationTime;
    delete dataToSend.messageTitle;
    return data;
  }
}
